export class Room {
  id: string;
  locationId: string;
  name: string;
  isDefault: boolean = true;
  isUsed: boolean = false;

  constructor(name?: string) {
    this.name = name;
  }
}
